import React from 'react';
import { useHistory } from 'react-router-dom';
import AUIButton from '@ancert/aui-button';
import AUIInputTextField from '@ancert/aui-input-text-field';
import AUIInputPasswordField from '@ancert/aui-input-password-field';
import { useNotification } from '@ancert/aui-notification-context';
import { useForm } from 'react-hook-form';
import { defaultValues, resolver } from './form';
import { postLogin } from '../../../services/user.service';
import { HOMEPAGE, ROUTES } from '../../../constants/routes.constants';
import { ROL } from '../../../lib/role.enum';

const Login = () => {
  const history = useHistory();
  const { openNotification } = useNotification();
  const { control, formState, handleSubmit } = useForm({
    defaultValues,
    resolver,
    mode: 'onSubmit',
  });

  const errorModal = (message) => {
    openNotification({
      title: 'Error',
      content: <div>{message || 'Ha ocurrido en el inicio de sesión.'}</div>,
      type: 'error',
      centerButtons: true,
    });
  };

  const onSubmit = async (data) => {
    const { status, data: result, error } = await postLogin({ data });
    if (status === 200) {
      const { jwtToken, refreshToken, user, renewPassword } = result;
      sessionStorage.setItem('jwtToken', jwtToken);
      sessionStorage.setItem('refreshToken', refreshToken);
      sessionStorage.setItem('user', btoa(JSON.stringify(user)));
      sessionStorage.setItem('renewPassword', btoa(JSON.stringify(renewPassword)));
      if (user?.role === ROL.DENUNCIANTE) {
        history.push(ROUTES.LISTADO_DENUNCIA);
      } else {
        history.push(ROUTES.BACK_OFFICE);
      }
      return;
    }

    const { message } = error;
    errorModal(status === 401 ? error : message);
  };

  return (
    <div className="c-sii-login">
      <h1>Consultar una denuncia previa</h1>
      <div className="c-sii-login__form">
        <p className="c-sii-login__desc">Introduce tus datos para acceder</p>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <div className="o-grid">
            <div className="o-grid__row">
              <div className="o-grid__col-12">
                <AUIInputTextField
                  required
                  name="user"
                  label="Usuario"
                  controlRef={control}
                  errors={formState.errors}
                />
              </div>
            </div>
            <div className="o-grid__row">
              <div className="o-grid__col-12">
                <AUIInputPasswordField
                  required
                  name="password"
                  label="Contraseña"
                  toogleMask
                  controlRef={control}
                  errors={formState.errors}
                />
              </div>
            </div>
          </div>
          <div className="c-sii-login__buttons">
            <AUIButton
              size="lg"
              type="submit"
              className="c-sii-login__submit"
              label="Consultar una denuncia previa"
              mode="secondary"
            />
            <a className="sii-link" href={`${HOMEPAGE}${ROUTES.RECORDAR_CONTRASENA}`}>
              ¿Has olvidado tu contraseña?
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
